import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/training-course-management`;

export const trainingCourseManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:trainingCourseId`,
  view: `${baseRoute}/view/:trainingCourseId`,
} as const;

export type ITrainingCourseManagementRouteParams = IExtractRouteParamMap<
  typeof trainingCourseManagementRoutesObj
>;

export const trainingCourseManagementPath = createPaths<
  typeof trainingCourseManagementRoutesObj,
  ITrainingCourseManagementRouteParams
>(trainingCourseManagementRoutesObj);
